import { compose } from 'recompose';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Icon from '../../Global/Icon';
import Text from '../../Global/Text';
import { replaceAll } from '../../../utilities/common';
import { getStepTitle, triggerView } from '../../../utilities/adobeTarget';
import { userDataService } from '../../../utilities/api/userData';
import { nextStepAction, prevStepAction } from '../../../actions/Section';
import { stepShowHide } from '../../../utilities/form/formUtils';

const MitIdButton = ({
  label,
  link,
  icon,
  target,
  className,
  tracking,
  columns,
  dataTealium,
  translations,
  iconPos,
  divClassName,
  hidden,
  dispatch,
  userData,
  showHide,
  values
}) => {
  const referer = window.location.href.split('?')[0];
  const params = {
    referer,
  };
  const encodeState = btoa(JSON.stringify(params));

  let linkurl = replaceAll(link, translations, {});
  if (encodeState !== '') {
    linkurl += encodeState;
  }

  if (userData.loginStatus === 'undefined' || !userData.loginStatus) {
    const viewName = getStepTitle();
    if (viewName) {
      triggerView(viewName);
    }
    dispatch(userDataService.saveUserData());
  } else {
    const stepAction = sessionStorage.getItem('action');
    if (stepAction === null || stepAction === 'next') {
      dispatch(nextStepAction());
    } else if (stepAction === 'prev') {
      dispatch(prevStepAction());
    }
  }

  if (stepShowHide(hidden, showHide, userData, values)) {
    return <div />;
  }

  return (
    !hidden && 
    <div className={`Widget_MitIdButton form__field--${columns}col ${divClassName}`}>
      <a
        href={linkurl}
        target={target}
        className={`${className} ${tracking}`}
        data-tealium={dataTealium}
      >
        {icon && iconPos === 'before' &&
        <Icon icon={icon}/>
        }
        <Text value={label}/>
        {icon && iconPos === 'after' &&
        <Icon icon={icon}/>
        }
      </a>
    </div>
  );
};

export default compose(
  connect(state => {
    const {
      section: {
        packageData: {
          translations,
        },
      },
    } = state;
    return {
      translations,
    };
  })
)(MitIdButton);

MitIdButton.defaultProps = {
  icon: null,
  target: '_blank',
  className: '',
  tracking: 'tealiumLink',
  columns: '12',
  dataTealium: null,
  iconPos: 'before',
  divClassName: '',
  showHide: null
};

MitIdButton.propTypes = {
  label: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  icon: PropTypes.string,
  target: PropTypes.string,
  className: PropTypes.string,
  tracking: PropTypes.string,
  columns: PropTypes.string,
  dataTealium: PropTypes.string,
  translations: PropTypes.object.isRequired,
  iconPos: PropTypes.string,
  divClassName: PropTypes.string,
  hidden: PropTypes.bool,
  dispatch: PropTypes.func.isRequired,
  userData: PropTypes.object,
  showHide: PropTypes.object,
  values: PropTypes.object
};